/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./discover-content.vue?vue&type=template&id=50a765c6&"
import script from "./discover-content.vue?vue&type=script&lang=js&"
export * from "./discover-content.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./discover-content.vue?vue&type=style&index=0&id=50a765c6&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports